import { DEFAULT_PIXEL_SIZE } from '../../../v2/foundation/spacing/utils.js';

var remToPx = function remToPx(value, base) {
  var baseValue = base || DEFAULT_PIXEL_SIZE;
  return value * baseValue;
};

export { remToPx };
